export default "__VITE_ASSET__97e1e757__"